// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/87ec97978c5458feead9.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"1a2f19e44ec13a36d108","180":"6097fbbf06d52dafff02","245":"32d95d772f0fd83cbdde","246":"e93b2e70ca8a8853097b","247":"d17ac22ce6ad09c4b6c7"}[chunkId] + ".chunk.js";
};